module.exports = __webpack_public_path__ + "img/mining-pool-bg.e56b98f2.png";